(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('ServantSearch', ServantSearch);

    ServantSearch.$inject = ['$resource', 'ENV'];

    function ServantSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/servants/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
